'use client'

import { useTranslations } from 'next-intl'

import {
  PassportVerificationButton,
  type PassportVerificationButtonProps,
} from '@/features/verify-identity'
import { Image, Notice } from '@/shared/ui'

type Props = PassportVerificationButtonProps & {
  passportImageUrl?: string | null
}

export const PassportVerification = ({
  isVerified,
  disabled,
  passportImageUrl,
}: Props) => {
  const t = useTranslations()

  const passportPreviewUrl =
    isVerified && passportImageUrl?.trim() ? passportImageUrl.trim() : null

  return (
    <section className="bg-gray-0 rounded-lg p-8.5 text-center">
      <div className="mb-4">
        <Notice.Title className="mb-1.5 justify-center">
          {isVerified
            ? t('passport_verification.passport_photo_uploaded_title')
            : t('verification.no_korean_phone_title')}
        </Notice.Title>
        <p className="typo-label1-reading whitespace-break-spaces text-gray-500">
          {t('verification.no_korean_phone_description')}
        </p>
      </div>
      {passportPreviewUrl && (
        <Image
          src={passportPreviewUrl}
          alt="여권"
          width={162}
          height={100}
          external={true}
          className="mx-auto mb-4 rounded-sm"
        />
      )}
      <PassportVerificationButton isVerified={isVerified} disabled={disabled} />
    </section>
  )
}
